export function getCreateDefinitionAndSetValuePath({sourceName}: {sourceName: string}) {
  return `/organizations/${encodeURIComponent(sourceName)}/settings/custom-properties/create-and-set-values`
}
